export default {
  root: {
    '& input[type="color"]': {
      height: 22,
      position: 'absolute',
      right: 5,
      top: 35,
      width: 50,
      padding: 0,
      border: '1px solid #ccc'
    },
    position: 'relative',
    '& input[type="color"]::-webkit-color-swatch-wrapper': {
      padding: 0
    },
    '& input[type="color"]::-webkit-color-swatch': {
      border: 0
    },
    '& a': {
      position: 'absolute',
      top: 37,
      left: 'calc(100% + 10px)',
      '& svg': {
        fill: '#df0000'
      }
    }
  }
};
